import Icon from '@mercadoni/sinister/dist/cjs/Icon'
import { Drawer } from 'antd'
import { useState } from 'react'
import styled from 'styled-components'
import DrawerHeader from '../decorators/DrawerHeader'
import HelperList from '../decorators/HelperList'
import PagesCollapse from '../decorators/PagesCollapse'

const StyledDrawer = styled(Drawer)`
  & .ant-drawer-header,
  & .ant-drawer-body {
    padding: 0;
  }
`

const StyledButton = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  padding: 0;
  justify-content: center;
  align-items: center;
  padding: 6px 18px 6px 6px;
  svg {
    color: var(--app-location-icon-color-mobile);
    margin-right: 0;
  }
`

const MoreAboutLayoutB = () => {
  const [open, setOpen] = useState(false)

  const handleOpenAndClose = () => {
    setOpen(!open)
  }
  const style = {
    marginRight: 'var(--spacing-margin-xSmall)',
    flexShrink: '0',
  }

  return (
    <>
      <StyledButton onClick={handleOpenAndClose}>
        <Icon
          size={20}
          color="var(--more-about-icon-color,#000000)"
          className="ph-list"
          style={style}
        />
      </StyledButton>
      <StyledDrawer
        title={<DrawerHeader onClose={handleOpenAndClose} />}
        placement="bottom"
        onClose={handleOpenAndClose}
        open={open}
        closable={false}
      >
        <PagesCollapse onCloseDrawer={handleOpenAndClose} />
        <HelperList />
      </StyledDrawer>
    </>
  )
}

export default MoreAboutLayoutB
